import { render, staticRenderFns } from "./WksDeliveryListByProd.vue?vue&type=template&id=3c2bc476&scoped=true"
import script from "./WksDeliveryListByProd.vue?vue&type=script&lang=js"
export * from "./WksDeliveryListByProd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2bc476",
  null
  
)

export default component.exports